"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var posthog_js_1 = require("posthog-js");
var posthogPlugin = function (config) {
    return {
        name: "posthog",
        config: config,
        initialize: function (_a) {
            var _b;
            var config = _a.config;
            if (!config.token) {
                throw new Error("No PostHog project API key defined");
            }
            posthog_js_1.posthog.init(config.token, {
                api_host: (_b = config.apiHost) !== null && _b !== void 0 ? _b : "https://us.posthog.com",
                autocapture: false,
            });
        },
        page: function (_a) {
            var payload = _a.payload;
            posthog_js_1.posthog.capture("$pageview", payload.properties);
        },
        track: function (_a) {
            var payload = _a.payload;
            posthog_js_1.posthog.capture(payload.event, payload.properties);
        },
        identify: function (_a) {
            var payload = _a.payload;
            posthog_js_1.posthog.identify(payload.userId, payload.traits);
        },
        loaded: function () {
            return posthog_js_1.posthog.__loaded;
        },
    };
};
exports.default = posthogPlugin;
